import styled, { css } from 'styled-components/macro'
import { switchProp, theme } from 'styled-tools'
import { media } from '../../ui/rwd'
import { Row, Col } from 'reactstrap'
import { MdClose, MdDone } from 'react-icons/md'

const Icon = css`
  width: 70px;
  height: 70px;
  max-width: 100%;
  border-radius: 50%;
  padding: 0.1em;
  background: white;
  margin-top: 5px;
  ${media.sm.down`
    width: 60px;
    height: 60px;
  `}
`

const ErrorIcon = styled(MdClose)`
  ${Icon}
  border: 7px solid ${theme('danger')};
  color: ${theme('danger')};
`

const DoneIcon = styled(MdDone)`
  ${Icon}
  border: 7px solid ${theme('productPlusButtonBackground', 'primary')};
  color: ${theme('productPlusButtonBackground', 'primary')};
`

const Header = styled.h1`
  color: ${props =>
    props.paymentApproved
      ? theme('productPlusButtonBackground', 'primary')
      : theme('danger')};
  font-weight: bold;
`

const CircleLine = styled.div`
  position: absolute;
  height: 0.25rem;
  left: calc(16.55vw + 23.06px);
  width: calc(33.56vw - 74.41px);
  top: 34px;
  ${media.sm`
    width: 7.2rem;
    top: 38px;
    left: 117px;
  `}
  ${media.md`
    width: 10rem;
    top: 38px;
    left: 138px;
  `}
  ${media.lg`
    width: 9.3rem;
    top: 38px;
    left: 137px;
  `}
  ${media.xl`
    width: 8.7rem;
    top: 38px;
    left: 137px;
  `}
  background: ${switchProp('color', {
    green: theme('productPlusButtonBackground', 'primary'),
    red: theme('danger')
  })};
`

const LoadingBox = styled(Row)`
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100%;
`

const LoadingBoxHeader = styled.h4`
  font-size: 24px;
  color: ${theme('secondary')};
  text-align: center;
  margin-bottom: 1rem;
  margin-top: 5rem;
`

const LoadingBoxLoader = styled.div`
  margin: 4.5rem 0;
`

const PaymentProgress = styled(Col)`
  text-align: center;
  margin: 1rem 0;
  ${media.sm.down`
    margin-left: -3rem;
    margin-right: -3rem;
  `}
`

const HeaderText = styled.h4`
  font-size: 24px;
  font-weight: 800;
  margin-top: 1.5rem;
  text-align: center;
`

const DescriptionText = styled.p`
  font-size: 24px;
  margin-top: 0.5rem;
  text-align: center;
`

export {
  DoneIcon,
  ErrorIcon,
  CircleLine,
  Header,
  LoadingBox,
  LoadingBoxHeader,
  LoadingBoxLoader,
  PaymentProgress,
  HeaderText,
  DescriptionText
}
